var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3052 2.56841V8.94265",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3054 2.56841V8.94265",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56802 11.7178H26.7347",
    stroke: "#F25C54",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84075 6.52568H24.7695C26.0248 6.52568 27.0423 7.5431 27.0423 8.79841V24.3151C27.0423 25.5704 26.0248 26.5878 24.7695 26.5878H5.84075C4.58545 26.5878 3.56802 25.5704 3.56802 24.3151V8.79841C3.56802 7.5431 4.58545 6.52568 5.84075 6.52568Z",
    stroke: "#231D1D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5135 17.043C10.5135 17.6188 10.0468 18.0847 9.47181 18.0847C8.89681 18.0847 8.43015 17.6188 8.43015 17.043C8.43015 16.468 8.89681 16.0014 9.47181 16.0014C10.0468 16.0014 10.5135 16.468 10.5135 17.043Z",
    fill: "#231D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.347 17.043C16.347 17.6188 15.8803 18.0847 15.3053 18.0847C14.7296 18.0847 14.2636 17.6188 14.2636 17.043C14.2636 16.468 14.7296 16.0014 15.3053 16.0014C15.8803 16.0014 16.347 16.468 16.347 17.043Z",
    fill: "#231D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1801 17.043C22.1801 17.6188 21.7142 18.0847 21.1384 18.0847C20.5634 18.0847 20.0967 17.6188 20.0967 17.043C20.0967 16.468 20.5634 16.0014 21.1384 16.0014C21.7142 16.0014 22.1801 16.468 22.1801 17.043Z",
    fill: "#231D1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5135 22.0434C10.5135 22.6184 10.0468 23.0851 9.47181 23.0851C8.89681 23.0851 8.43015 22.6184 8.43015 22.0434C8.43015 21.4677 8.89681 21.0017 9.47181 21.0017C10.0468 21.0017 10.5135 21.4677 10.5135 22.0434Z",
    fill: "#231D1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.347 22.0434C16.347 22.6184 15.8803 23.0851 15.3053 23.0851C14.7296 23.0851 14.2636 22.6184 14.2636 22.0434C14.2636 21.4677 14.7296 21.0017 15.3053 21.0017C15.8803 21.0017 16.347 21.4677 16.347 22.0434Z",
    fill: "#231D1D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1801 22.0434C22.1801 22.6184 21.7142 23.0851 21.1384 23.0851C20.5634 23.0851 20.0967 22.6184 20.0967 22.0434C20.0967 21.4677 20.5634 21.0017 21.1384 21.0017C21.7142 21.0017 22.1801 21.4677 22.1801 22.0434Z",
    fill: "#231D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.ee1ebb08f9f8a3291cb394200a241e5d.svg";
export { ForwardRef as ReactComponent };